export default "__VITE_ASSET__BD_fL_Lu__"